export const defaultAddressFieldsNames = ['city', 'country', 'state', 'street', 'zipCode']
